<template>
  <div>
    <le-loading v-if="isLoading"></le-loading>
    <div v-else>
      <div class="row">
      <div v-for="team in teams" :key="team.uuid" class="col-12 col-md-6 mb-5">
        <h4 class="mb-3">{{ team.name }}</h4>
        <div class="row">
          <div v-for="player in team.players" :key="player.uuid" class="col-12 mb-3">
            <div class="media align-items-center p-2 border rounded">
              <div class="position-relative mr-3 flex-shrink-0" style="cursor: pointer;" @click="openCropModal(player)">
                <img
                  :src="player.profile || '/empty-player.jpg'"
                  class="img-avatar img-avatar48 rounded-circle"
                  :alt="player.name"
                >
                <span
                  v-if="player.number_of_jersey != null"
                  class="badge badge-primary position-absolute"
                  style="bottom: -4px; right: -6px; font-size: 10px;"
                >
                  {{ player.number_of_jersey }}
                </span>
              </div>
              <div class="media-body min-width-0">
                <div class="font-w600 text-truncate">{{ player.lastName }}</div>
                <div class="text-muted small text-truncate">{{ player.firstName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <ntm-modal @closed="selectedPlayer = null" size="lg" ref="cropModal">
      <ntm-crop
        v-if="selectedPlayer"
        :key="selectedPlayer.uuid"
        @change="onProfileUpdated"
        entity-type="player"
        :entity-uuid="selectedPlayer.uuid"
        collection="profile"
        :circle="true"
      ></ntm-crop>
    </ntm-modal>
  </div>
</template>

<script>
import GamePhotosService from '@/services/gamePhotos.service'
import LeLoading from '@/components/le/LeLoading.vue'

export default {
  name: 'LeGalleryPlayers',
  components: { LeLoading },
  props: {
    gameUuid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      teams: [],
      selectedPlayer: null
    }
  },
  mounted () {
    this.fetchPlayers()
  },
  methods: {
    fetchPlayers () {
      this.isLoading = true
      GamePhotosService.players(this.gameUuid).then((response) => {
        this.teams = [response.data.homeTeam, response.data.awayTeam]
      }).finally(() => {
        this.isLoading = false
      })
    },
    openCropModal (player) {
      this.selectedPlayer = player
      this.$refs.cropModal.open()
    },
    onProfileUpdated (imageUrl) {
      const player = this.teams
        .flatMap(t => t.players)
        .find(p => p.uuid === this.selectedPlayer.uuid)
      if (player) {
        player.profile = imageUrl
      }
      this.$refs.cropModal.close()
    }
  }
}
</script>
